module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dialogues"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "play-1"
    }
  }, [_c('h2', [_vm._v("Play 1")]), _vm._v(" "), _c('p', [_vm._v("Time and place: "), _c('em', [_vm._v("Wherever or whenever you happen to be at the time.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Characters: "), _c('em', [_vm._v("I don’t know yet.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Act 1:")])]), _vm._v(" "), _c('em', [_vm._v("Here and now!")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "99%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "8%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "93%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("What’s the matter, Gertrude.")])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("I have a splitting headache.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("From what? Your busy schedule? Those tea socials must be nerve wracking.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Cut the crap, Harry. You know I just do more than those things. Like…")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Yeah, I know. The Ladies this and that…The Emergency Fund for whatever. What is it this week? Poodles who can’t afford a haircut or maids who need a new duster?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("I am getting very annoyed with your sarcasm and I…")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("And you what?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Oh never mind!")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("You see I AM RIGHT!")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("About what? Besides, I am getting sick and tired of this same conversation over and over again.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Then don’t do the same things over and over and over again. It’s very simple!")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Unfortunately for you and fortunately for me, I am not a simple person. I am a very complex human being who has chores in life that are there for improving the human condition. You just don’t understand things Har!")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("I understand things plenty!")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("No, you don’t! I am getting quite annoyed with you. Why don’t you just accept me for the way I am!")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("I am really trying to. But there are so many more things to life than tea and biscuits.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Like what?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Like daisies…like birds singing…like the ice cream guy with his music…or even going to a movie. Or even a hot dog with mustard instead of some boring little fluff of dough.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Fluff?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("FLUFF!")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("I’m tired. Goodbye!")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("So much for discourse.")])])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Act 2:")])]), _c('em', [_vm._v("Then and later. Wrapping it almost.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "99%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "94%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Hello, Gertrude.")])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Hello, Harry.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("And how are we this fine day?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Okay. But I still don’t like the way you mocked me yesterday.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("I meant no offense. You’re a fine individual with wonderful gifts and talents.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Well it’s about time!")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Are we going to go down that road again, Gertrude?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("That’s the main road. That’s my road. The way you go is always down the detour and into the ditch or Slobovia! Or some other God-forsaken place!")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude…Gertrude…my Gertrude! You constantly amaze and baffle me all at the same time!")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("I told you I was a very complex human being.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Yes, you did. Yes, you did.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Oh, by the way Harry, I have to go now.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Why? Another meeting with the Humane Society?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Gertrude:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Widows and orphans of uh, uh. I can’t quite remember how they were widowed and orphaned but they were! We are going to give each one of them a gift certificate for a months’ free meals at the automat. Now, ta-ta Harry.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Harry:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Ta-ta.")])])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Act 3:")])]), _c('em', [_vm._v("Just a moment later.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "99%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "89%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Expert 1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("That didn’t work either.")])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Expert 2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Another miserable failure.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Expert 1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("I wish we could wrap this thing up. Volunteers are expensive to come by.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Expert 2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Especially when they have to talk the same and look the same.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Expert 1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("She’s such a nice old lady. Reminds me a little of my grand’.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Expert 2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("A little like everybody’s…huh?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Expert 1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Yep.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Expert 2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("I suppose little ole’ ladies can be crazy since they have so much to offer from their wit and wisdom. And they are old!")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Expert 1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("You’re right. Maybe we’re the ones that should be analyzed.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Expert 2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("How ’bout lunch?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Expert 1:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Crackers and tea?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Expert 2:")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("We are crazy!")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd355748","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0007.vue
// module id = 90
// module chunks = 0